import {
  matchPath,
  PathMatch,
  ParamParseKey,
  Location,
  PathPattern,
} from 'react-router-dom';
import { map } from 'rxjs/operators';
import { history$ } from '../../services/browserHistory';

export type URLState<
  ParamKey extends ParamParseKey<Path>,
  Path extends string,
  SearchParams extends { [K in keyof SearchParams]?: string } = Record<
    string,
    never
  >
> = PathMatch<ParamKey> &
  Location & {
    searchParams: SearchParams;
  };

export const stateFromUrl = <
  ParamKey extends ParamParseKey<Path>,
  Path extends string,
  SearchParams extends { [K in keyof SearchParams]?: string } = Record<
    string,
    never
  >
>(
  routes: (PathPattern<Path> | Path)[] = []
) => {
  return history$.pipe(
    map((location): URLState<ParamKey, Path, SearchParams> | null => {
      if (!location) {
        return null;
      }

      const { pathname, search } = location;

      for (let i = 0; i < routes.length; i++) {
        const match = matchPath<ParamKey, Path>(routes[i], pathname);

        if (match) {
          const searchParams = {} as SearchParams;
          for (const [key, value] of new URLSearchParams(search)) {
            Object.assign(searchParams, { [key]: value });
          }

          return { ...location, ...match, searchParams };
        }
      }

      return null;
    })
  );
};
